module.exports = __webpack_public_path__ + "static/media/ic_ideate.07d17c08.svg";